import React, { useId } from "react";
import classNames from "classnames";
import styles from "./sidebarMenuTab.module.css";
import { TooltipTemplate } from "UiKit";
function SidebarMenuTab({ item, activeKey, handleTabClick }) {
    const tooltipId = useId();
    const Element = (item === null || item === void 0 ? void 0 : item.hash) ? "a" : "div";
    return (React.createElement(Element, { id: tooltipId, href: item === null || item === void 0 ? void 0 : item.hash, className: classNames(styles.tab, {
            [styles.active]: (item === null || item === void 0 ? void 0 : item.key) === activeKey
        }), onClick: () => handleTabClick(item === null || item === void 0 ? void 0 : item.key) },
        (item === null || item === void 0 ? void 0 : item.icon) && (React.createElement("i", { className: classNames(styles.icon, item.icon, !/(^| )text-\w+-\d+($| )/.test(item.icon)) })),
        React.createElement(TooltipTemplate, { id: tooltipId, position: "right" },
            React.createElement("span", null, item === null || item === void 0 ? void 0 : item.title))));
}
export default SidebarMenuTab;
